var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWolverineAiq01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 704.84,
    height: 168,
    viewBox: "0 0 704.84 168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M244.86,29h17.76L235.84,94.51l-20-37.3L196,94.51,169.21,29h17.67l12.2,35.26,16.79-38.35,17,38.35Z",
    fill: "#33336f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.17,46.87a30.89,30.89,0,0,1,7-10.25A31.44,31.44,0,0,1,284.8,30a38.34,38.34,0,0,1,26.38,0,31.62,31.62,0,0,1,10.56,6.67,30.35,30.35,0,0,1,7,10.25A33.61,33.61,0,0,1,331.19,60a34.84,34.84,0,0,1-2.43,13.17,30.77,30.77,0,0,1-6.89,10.43,31.32,31.32,0,0,1-10.56,6.85,38.11,38.11,0,0,1-26.78,0A31.32,31.32,0,0,1,274,83.55a30.77,30.77,0,0,1-6.89-10.43A34.84,34.84,0,0,1,264.65,60,33.09,33.09,0,0,1,267.17,46.87Zm15.46,22.76a16.28,16.28,0,0,0,6.1,6.58A17.46,17.46,0,0,0,298,78.6a17.28,17.28,0,0,0,9.14-2.39,16.28,16.28,0,0,0,6.1-6.58A20.85,20.85,0,0,0,315.37,60a21.08,21.08,0,0,0-2.12-9.67,16,16,0,0,0-6-6.59,19.18,19.18,0,0,0-18.51,0,16.31,16.31,0,0,0-6.1,6.59A20.84,20.84,0,0,0,280.47,60,20.85,20.85,0,0,0,282.63,69.63Z",
    fill: "#33336f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.67,29V78.07H380.5V90.88H340.74V29Z",
    fill: "#33336f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.57,29h17.49L404.45,94.77,371.93,29h17.41L404.45,66Z",
    fill: "#33336f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.83,29V90.88H443.51V29Zm-4.42,0H484.6V41.31H453.41Zm0,23.33h29.43v12H453.41Zm0,26.25H484.6V90.88H453.41Z",
    fill: "#33336f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.73,29V90.88H496.8V29Zm-5.56,0h13.16a30.37,30.37,0,0,1,13.26,2.57,18.48,18.48,0,0,1,8,7.11,20,20,0,0,1,2.74,10.56,19.85,19.85,0,0,1-2.74,10.47,18.44,18.44,0,0,1-8,7.12,30.37,30.37,0,0,1-13.26,2.56H506.17V57.83h12.1a13,13,0,0,0,5.17-.93,7.1,7.1,0,0,0,3.32-2.73,8.9,8.9,0,0,0,0-8.75,7.39,7.39,0,0,0-3.32-2.79,12.49,12.49,0,0,0-5.17-1h-12.1Zm21.56,33.85,19.35,28H529.59l-17.33-28Z",
    fill: "#33336f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.17,29V90.88H554V29Z",
    fill: "#33336f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.34,29V94L596.57,56.06V90.88H582.25V25.93l42.69,37.91V29Z",
    fill: "#33336f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.73,29V90.88H652.42V29Zm-4.41,0h31.19V41.31H662.32Zm0,23.33h29.42v12H662.32Zm0,26.25h31.19V90.88H662.32Z",
    fill: "#33336f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "144.35 60.56 141.62 72.41 139.54 75.31 122.77 85.7 123.24 104.11 121.89 107.51 87.58 141.96 84.27 140.59 80.96 141.96 46.65 107.51 45.3 104.11 45.77 85.7 29 75.31 26.92 72.41 24.18 60.55 0.73 84 84.26 167.53 167.79 84 144.35 60.56",
    fill: "#33336f"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.55 43.48 84.27 44.09 84.99 43.48 100.06 45.8 116.11 32.32 84.26 0.47 52.41 32.31 68.48 45.8 83.55 43.48",
    fill: "#33336f"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.91 48.08 84.27 44.09 79.63 48.08 79.63 138.68 84.27 140.59 88.91 138.68 88.91 48.08",
    fill: "#33336f"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.73,
    y: 39.47,
    width: 89.05,
    height: 89.05,
    transform: "translate(84.08 -34.98) rotate(45)",
    fill: "#fdb813"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "67.1 50.72 16.98 8.63 31.45 71.36 50.48 83.15 49.95 104.22 84.26 138.68 84.26 48.08 67.1 50.72",
    fill: "#33336f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.26,99.94l-1.34.69.49,2.72-1.62.87-.75.4-1.63.87L78.67,104l-.73.77.13,1.52-1.21.85-2.68-2.31s-.12,6.56,2.43,11.3c0,0-5.46-3.53-6.44-8.63s1.58-6.19,1.58-6.19l8.87-4.38-3.51-3.76,7.15-1.7Z",
    fill: "#fdb813"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.26,126.63l-1.94,1.75v-2l-1.85,1v-2.18a10,10,0,0,1-4.85-8.54s-2.27,7.18,1.49,10.77,3.75,2.81,3.75,2.81l1,2.43h2.43Z",
    fill: "#fdb813"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.56 73.32 55.43 63.48 65.12 82.35 80.78 85.99 73.56 73.32",
    fill: "#fdb813"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.69 77.5 65.79 72.68 70.55 81.94 78.23 83.72 74.69 77.5",
    fill: "#33336f"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.26 67.5 75.79 59.82 84.26 71.7 84.26 67.5",
    fill: "#fdb813"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.08 93.54 81.7 95.46 83.91 93.54 81.08 93.54",
    fill: "#33336f"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.74 106.03 53.48 107.77 53.74 104.03 51.74 106.03",
    fill: "#fdb813"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.18 114.76 63.78 118.36 64.31 110.63 60.18 114.76",
    fill: "#fdb813"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.53 109.18 59.02 113.68 59.69 104.03 54.53 109.18",
    fill: "#fdb813"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.21 51.82 67.71 56.32 68.37 46.66 63.21 51.82",
    fill: "#fdb813"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.34 93.54 61.11 87.97 79.34 93.97 79.34 93.54",
    fill: "#fdb813"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.08 95.66 58.43 96.5 80.25 96.13 80.08 95.66",
    fill: "#fdb813"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.86 94.35 55.57 92.42 80.99 94.92 80.86 94.35",
    fill: "#fdb813"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "101.43 50.72 151.56 8.63 137.09 71.36 118.05 83.15 118.59 104.22 84.28 138.68 84.28 48.08 101.43 50.72",
    fill: "#33336f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.28,99.94l1.34.69-.49,2.72,1.62.87.75.4,1.63.87.73-1.52.74.77-.13,1.52,1.21.85,2.67-2.31s.13,6.56-2.43,11.3c0,0,5.47-3.53,6.44-8.63s-1.58-6.19-1.58-6.19L87.92,96.9l3.51-3.76-7.15-1.7Z",
    fill: "#fdb813"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.28,126.63l1.94,1.75v-2l1.84,1v-2.18a10,10,0,0,0,4.86-8.54s2.27,7.18-1.49,10.77-3.75,2.81-3.75,2.81l-1,2.43H84.28Z",
    fill: "#fdb813"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.98 73.32 113.11 63.48 103.41 82.35 87.75 85.99 94.98 73.32",
    fill: "#fdb813"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.85 77.5 102.75 72.68 97.99 81.94 90.3 83.72 93.85 77.5",
    fill: "#33336f"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.28 67.5 92.75 59.82 84.28 71.7 84.28 67.5",
    fill: "#fdb813"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.46 93.54 86.83 95.46 84.63 93.54 87.46 93.54",
    fill: "#33336f"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.8 106.03 115.05 107.77 114.8 104.03 116.8 106.03",
    fill: "#fdb813"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.35 114.76 104.76 118.36 104.22 110.63 108.35 114.76",
    fill: "#fdb813"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.01 109.18 109.52 113.68 108.85 104.03 114.01 109.18",
    fill: "#fdb813"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.32 51.82 100.83 56.32 100.17 46.66 105.32 51.82",
    fill: "#fdb813"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.19 93.54 107.43 87.97 89.19 93.97 89.19 93.54",
    fill: "#fdb813"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.45 95.66 110.1 96.5 88.29 96.13 88.45 95.66",
    fill: "#fdb813"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.67 94.35 112.97 92.42 87.55 94.92 87.67 94.35",
    fill: "#fdb813"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M179.75,131.08l-.09,1.17-4.35,9.82h-6l15.34-33.14L200,142.07h-6l-4.26-9.55-.13-1.3-5-11.66Zm-2.29-1.57H192l1,4.49H176.48Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.05,110.68v33L215.13,121v21.08h-5.2v-33l22.91,22.65V110.68Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.36,131.08l-.09,1.17-4.35,9.82h-6l15.34-33.14,15.34,33.14h-6l-4.26-9.55-.13-1.3-5-11.66Zm-2.29-1.57h14.57l1,4.49h-16.6Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.87,110.68v31.39h-5.33V110.68Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.59,119.87a15.36,15.36,0,0,1,3.45-5.13,15.92,15.92,0,0,1,5.2-3.39,17.9,17.9,0,0,1,12.94,0,15.85,15.85,0,0,1,5.16,3.39,15.41,15.41,0,0,1,3.41,5.13,17.13,17.13,0,0,1,1.21,6.5,17.41,17.41,0,0,1-1.21,6.51,15.44,15.44,0,0,1-8.52,8.63,17.92,17.92,0,0,1-13.05,0,15.37,15.37,0,0,1-8.62-8.63,17.41,17.41,0,0,1-1.21-6.51A16.59,16.59,0,0,1,323.59,119.87Zm5.8,12.42a10.54,10.54,0,0,0,3.93,4,11.56,11.56,0,0,0,11.14,0,10,10,0,0,0,3.81-3.92,11.64,11.64,0,0,0,1.39-5.74,12.13,12.13,0,0,0-1.39-5.83,11.09,11.09,0,0,0-15.11-4.22,10.32,10.32,0,0,0-3.81,4,11.75,11.75,0,0,0-1.39,5.76A11.93,11.93,0,0,0,329.39,132.29Zm13.95-3.67,14.13,13.67h-6.24l-14-13.67Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.4,110.68v31.39h-5.21V110.68Zm-1.93,0H403.3v4.66H387.47Zm0,12.29H402.4v4.57H387.47Zm0,14.44H403.3v4.66H387.47Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.82,110.68l-9.51,15.07,10.18,16.32H433L426.3,130l-6.95,12.06h-6.41l10.4-16.32-9.28-15.07h6.41l5.88,10.63,6-10.63Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.87,110.68v31.39h-5.29V110.68Zm-2.15,0H459a13.75,13.75,0,0,1,5.94,1.19,9.13,9.13,0,0,1,3.93,3.36,10.38,10.38,0,0,1,0,10.38A9.07,9.07,0,0,1,465,129a13.9,13.9,0,0,1-5.94,1.19h-6.32v-4.67H459a6.89,6.89,0,0,0,4.39-1.3,4.55,4.55,0,0,0,1.66-3.81,4.48,4.48,0,0,0-1.66-3.79,7,7,0,0,0-4.39-1.28h-6.32Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487,110.68v31.39h-5.2V110.68Zm-1.93,0h15.83v4.66H485.05Zm0,12.29H500v4.57H485.05Zm0,14.44h15.83v4.66H485.05Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519,110.68v31.39h-5.29V110.68Zm-2.15,0h6.55a13.61,13.61,0,0,1,5.94,1.21,9.22,9.22,0,0,1,3.92,3.38,9.33,9.33,0,0,1,1.39,5.14,9.44,9.44,0,0,1-1.39,5.16,9.13,9.13,0,0,1-3.92,3.4,13.61,13.61,0,0,1-5.94,1.22H516.8v-4.35h6.32a7.46,7.46,0,0,0,3.16-.63,4.82,4.82,0,0,0,2.13-1.82,5.7,5.7,0,0,0,0-5.72,4.89,4.89,0,0,0-2.13-1.79,7.46,7.46,0,0,0-3.16-.63H516.8Zm9.06,16.41,10.63,15h-6.37l-10-15Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552,110.68v31.39h-5.34V110.68Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.43,110.68v31.39h-5.2V110.68Zm-1.93,0h15.83v4.66H568.5Zm0,12.29h14.94v4.57H568.5Zm0,14.44h15.83v4.66H568.5Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.23,110.68v33L602.32,121v21.08h-5.2v-33L620,131.76V110.68Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.87,132.2a10.47,10.47,0,0,0,3.94,3.88,10.62,10.62,0,0,0,5.32,1.37,12.94,12.94,0,0,0,4-.58,12.44,12.44,0,0,0,3.25-1.59A13.27,13.27,0,0,0,663,133v6.28a15,15,0,0,1-4.26,2.47,16.83,16.83,0,0,1-5.74.85,17.5,17.5,0,0,1-6.44-1.17,15,15,0,0,1-5.18-3.36,15.83,15.83,0,0,1-3.43-5.18,17.92,17.92,0,0,1,0-13.05,15.72,15.72,0,0,1,3.43-5.18,14.76,14.76,0,0,1,5.18-3.36,17.5,17.5,0,0,1,6.44-1.17,16.59,16.59,0,0,1,5.74.85,15,15,0,0,1,4.26,2.47v6.28a13,13,0,0,0-2.54-2.27,12.44,12.44,0,0,0-3.25-1.59,12.94,12.94,0,0,0-4-.58,10.66,10.66,0,0,0-9.26,5.22,12,12,0,0,0,0,11.68Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.93,110.68v31.39h-5.2V110.68Zm-1.93,0h15.83v4.66H679ZM679,123h14.94v4.57H679Zm0,14.44h15.83v4.66H679Z",
    fill: "#606060"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWolverineAiq01);
export default __webpack_public_path__ + "static/media/Wolverine_AIQ-01.0dc3c71fe211bb44b8cf56010788e3c8.svg";
export { ForwardRef as ReactComponent };